<template>
  <SoPageWithHeader title="SMS Sender">
    <SoTabs v-model="activeTab">
      <SoTab title="Send Batch">
        <div class="pt-4">
          <SmsSenderForm @batch-sent="onBatchSent" />
        </div>
      </SoTab>
      <SoTab title="Batch History">
        <div class="pt-4">
          <SmsBatchList ref="batchList" />
        </div>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import SmsSenderForm from "@/views/operations/smsSender/components/SmsSenderForm.vue"
  import SmsBatchList from "@/views/operations/smsSender/components/SmsBatchList.vue"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoTabs,
      SoTab,
      SmsSenderForm,
      SmsBatchList,
    },
    data() {
      return {
        activeTab: 0,
      }
    },
    methods: {
      onBatchSent() {
        this.activeTab = 1
        ;(this.$refs.batchList as InstanceType<typeof SmsBatchList>).refetch()
      },
    },
  })
</script>
